(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["4"] && !Shopify.designMode) return;
  try {
    
  // ================================================================
  //  Product Hotspot 交互脚本
  // ================================================================
  (function() {
    'use strict';

    const template = document.getElementById('hotspot-popup-template');
    const overlay = document.querySelector('[data-popup-overlay]');
    let activePopup = null;

    function createPopup(hotspot) {
      if (!template) return null;

      const clone = template.content.cloneNode(true);
      const popup = clone.querySelector('[data-hotspot-popup]');
      
      const title = hotspot.dataset.productTitle || '产品';
      const image = hotspot.dataset.productImage || '';
      const price = hotspot.dataset.productPrice || '';
      const compare = hotspot.dataset.productCompare || '';
      const url = hotspot.dataset.productUrl || '#';
      const productId = hotspot.dataset.productId || '';
      const variantId = hotspot.dataset.variantId || '';
      const variants = parseInt(hotspot.dataset.productVariants) || 1;

      const titleEl = popup.querySelector('[data-popup-title]');
      const imageEl = popup.querySelector('[data-popup-image]');
      const priceEl = popup.querySelector('[data-popup-price]');
      const link = popup.querySelector('.hotspot-popup__link');
      const addBtn = popup.querySelector('[data-quick-add-btn]');

      if (titleEl) titleEl.textContent = title;
      if (link) link.href = url;
      if (imageEl) {
        imageEl.src = image || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23f0ede7"/%3E%3Ctext x="50" y="55" text-anchor="middle" font-family="system-ui" font-size="14" fill="%23999"%3E无图片%3C/text%3E%3C/svg%3E';
        imageEl.alt = title;
      }
      
      if (priceEl) {
        if (compare && compare !== price) {
          priceEl.innerHTML = `<span class="price price--sale">
            <s class="price-item--regular">${compare}</s>
            <span class="price-item--sale">${price}</span>
          </span>`;
        } else {
          priceEl.innerHTML = `<span class="price">${price}</span>`;
        }
      }

      if (addBtn) {
        if (variants > 1) {
          addBtn.textContent = '选择选项';
          addBtn.className = 'quick-add__button quick-add__button--secondary';
          addBtn.onclick = function(e) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = url;
          };
        } else {
          addBtn.dataset.productId = productId;
          addBtn.dataset.variantId = variantId;
          addBtn.textContent = '加入购物车';
          addBtn.className = 'quick-add__button quick-add__button--primary';
        }
      }

      const closeBtn = popup.querySelector('[data-popup-close]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          closePopup();
        });
      }

      if (overlay) {
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay) {
            closePopup();
          }
        });
      }

      return popup;
    }

    function showPopup(hotspot) {
      closePopup();

      const popup = createPopup(hotspot);
      if (!popup) return;

      document.body.appendChild(popup);
      activePopup = popup;

      if (overlay) {
        overlay.classList.add('is-active');
      }

      requestAnimationFrame(() => {
        popup.classList.add('is-active');
      });

      const escHandler = function(e) {
        if (e.key === 'Escape') {
          closePopup();
          document.removeEventListener('keydown', escHandler);
        }
      };
      document.addEventListener('keydown', escHandler);
      popup._escHandler = escHandler;
    }

    function closePopup() {
      if (activePopup) {
        activePopup.classList.remove('is-active');
        
        if (activePopup._escHandler) {
          document.removeEventListener('keydown', activePopup._escHandler);
        }

        setTimeout(() => {
          if (activePopup && activePopup.parentNode) {
            activePopup.parentNode.removeChild(activePopup);
          }
          activePopup = null;
        }, 300);
      }

      if (overlay) {
        overlay.classList.remove('is-active');
      }
    }

    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-hotspot-trigger]');
      
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        const hotspot = trigger.closest('product-hotspot');
        if (hotspot) {
          showPopup(hotspot);
        }
        return;
      }

      if (e.target.closest('.hotspot-popup')) {
        return;
      }

      if (!e.target.closest('product-hotspot')) {
        closePopup();
      }
    });

    document.addEventListener('click', function(e) {
      const btn = e.target.closest('[data-quick-add-btn]');
      if (btn && btn.dataset.productId) {
        e.preventDefault();
        e.stopPropagation();
        
        const productId = btn.dataset.productId;
        const variantId = btn.dataset.variantId || '';
        
        const originalText = btn.textContent;
        btn.textContent = '✅ 已添加';
        btn.style.background = '#2e7d32';
        btn.style.borderColor = '#2e7d32';
        btn.style.color = 'white';
        
        setTimeout(() => {
          btn.textContent = originalText;
          btn.style.background = '';
          btn.style.borderColor = '';
          btn.style.color = '';
        }, 2000);
        
        console.log('🛒 添加到购物车: 产品ID=' + productId + ', 变体ID=' + variantId);
      }
    });

    console.log('✅ Product Hotspots 已初始化');
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
